var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoResult = function SvgNoResult(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9798 14.3934C13.3708 14.7811 14.0016 14.7798 14.391 14.3906C14.7803 14.0013 14.7818 13.3705 14.3942 12.9794L11.5648 10.1502C11.173 9.76813 10.5467 9.77205 10.1596 10.1591C9.77259 10.5461 9.76857 11.1723 10.1506 11.5642L12.9798 14.3934Z",
    fill: "#FC628F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.02 35.6063C36.6291 35.2186 35.9983 35.2199 35.6089 35.6092C35.2195 35.9985 35.2181 36.6292 35.6056 37.0203L38.434 39.8495C38.6855 40.1075 39.0563 40.2103 39.4047 40.1185C39.7532 40.0267 40.0253 39.7547 40.1171 39.4063C40.2089 39.0579 40.1062 38.687 39.8482 38.4355L37.02 35.6063Z",
    fill: "#FC628F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.02 14.3938L39.8484 11.5646C40.1063 11.3131 40.2091 10.9422 40.1173 10.5939C40.0254 10.2455 39.7533 9.97338 39.4049 9.88163C39.0565 9.78988 38.6857 9.89263 38.4342 10.1506L35.6066 12.9802C35.219 13.3713 35.2205 14.0021 35.6099 14.3913C35.9993 14.7806 36.63 14.7819 37.021 14.3942L37.02 14.3938Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9798 35.6061L10.1506 38.4353C9.76857 38.8272 9.77259 39.4535 10.1596 39.8405C10.5467 40.2275 11.173 40.2314 11.5648 39.8493L14.3932 37.0197C14.6477 36.7674 14.7477 36.3983 14.6554 36.052C14.5631 35.7058 14.2927 35.4354 13.9464 35.3433C13.6002 35.2511 13.2311 35.3512 12.9788 35.6057L12.9798 35.6061Z",
    fill: "#FC628F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10C25.5523 10 26 9.55229 26 9V1C26 0.447715 25.5523 0 25 0C24.4477 0 24 0.447715 24 1V9C24 9.55229 24.4477 10 25 10Z",
    fill: "#FC628F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40C24.4477 40 24 40.4477 24 41V49C24 49.5523 24.4477 50 25 50C25.5523 50 26 49.5523 26 49V41C26 40.4477 25.5523 40 25 40Z",
    fill: "#FC628F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24H1C0.447715 24 0 24.4477 0 25C0 25.5523 0.447715 26 1 26H9C9.55229 26 10 25.5523 10 25C10 24.4477 9.55229 24 9 24Z",
    fill: "#FC628F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49 24H41C40.4477 24 40 24.4477 40 25C40 25.5523 40.4477 26 41 26H49C49.5523 26 50 25.5523 50 25C50 24.4477 49.5523 24 49 24Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoResult);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-result.57ae2dca1f01ac363f9c08531177c60d.svg";